import React, { useState, useEffect } from 'react';
import {useHistory } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Alert from 'react-bootstrap/Alert';
import Image from 'react-bootstrap/Image';
import FormWizard from "react-form-wizard-component";
import Spinner from 'react-bootstrap/Spinner';
import "react-form-wizard-component/dist/style.css";
import { BsUmbrella, BsPerson, BsPhone  } from "react-icons/bs";
import MaskedFormControl from 'react-bootstrap-maskedinput'
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css';
import Toast from 'react-bootstrap/Toast';


const LeadForm = (props) => {
    const [years, setYears] = useState([]);
    const [makes, setMakes] = useState([]);
    const [models, setModels] = useState([]);
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMake, setSelectedMake] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [vehicles, setVehicles] = useState('');
    const [selectedInsured, setSelectedInsured] = useState('');
    const [selectedInsuredBefore, setSelectedInsuredBefore] = useState('');
    const [isInsured, setIsInsured] = useState(false);
    const [selectedInsuredDuration, setSelectedInsuredDuration] = useState('');
    const [isHomeowner, setIsHomeowner] = useState('');
    const [additionalDrivers, setAdditionalDrivers] = useState(false);
    const [birthdate, setBirthdate] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [gender, setGender] = useState('');
    const [isMarried, setIsMarried] = useState('');
    const [hasDui, setHasDui] = useState('');
    const [isMilitary, setIsMilitary] = useState('');
    const [hasAccidents, setHasAccidents] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [personalIndex, setPersonalIndex] = useState(1);
    const [dobMonth, setDobMonth] = useState('');
    const [dobDay, setDobDay] = useState('');
    const [dobYear, setDobYear] = useState('');
    const [confirm, setConfirm] = useState(false);
    const [required, setRequired] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [progress, setProgress] = useState('');
    const [currentTab, setCurrentTab] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [callRep, setCallRep] = useState('');
    const [deductibles, setDeductibles] = useState('');
    const [renewalDate, setRenewalDate] = useState('');
    const [additionalDriversName, setAdditionalDriversName] = useState('');
    const [additionalDriversBirthdate, setAdditionalDriversBirthdate] = useState('');
    const [replaceRoof, setReplaceRoof] = useState('');
    const [insCarriers, setInsCarriers] = useState([]);
    const [show, setShow] = useState(false);
    const [incidents, setIncidents] = useState('');
    const [notes, setNotes] = useState('');
    const [propertyType, setPropertyType] = useState('');
    const [validated, setValidated] = useState(false);


    const history = useHistory();

    const formWizardRef = React.createRef();

    useEffect(async () => {
        try {
            getInsuranceCarriers();
            const leadId = localStorage.getItem('leadId');
            if(leadId == null){
                
                const yearResponse = await fetch("https://humble100.leadmanagertraining.com/api/autoquote/getYears", { 
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });
                const yearRange = await yearResponse.json();
                setYears(yearRange);
                console.log(years.years);
                InsertProgress("Personal");
            } else {
                history.push('/Confirmation');
            }
        }
        catch(e) {
            console.log('Submit Failed', e);
        }
    }, []);

    const onSubmit = (e) => {
        e.preventDefault(); 
    }

    const InsertProgress = (tab) => {
        console.log("Inside InsertProgress");
        const response = fetch("https://humble100.leadmanagertraining.com/api/autoquote/InsertProgress?tab=" + tab, { 
            method: 'POST',
            
        });
        const result = response;
        //setProgress(result);
    }
    const getInsuranceCarriers = async (e) => {
        const response = await fetch("https://humble100.leadmanagertraining.com/api/ActivityLog/GetTypeCurrentCarriers", { 
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        const jsonResponse = await response.json();
        setInsCarriers(jsonResponse);
    };
    const handleComplete = async () => {
        setIsSaving(true);
            //setValidated(true);
        const request = {
            address1: address,
            city: city,
            state: state,
            zip: zip,
            firstName: firstName,
            lastName: lastName,
            primaryPhone: phone, 
            email: email,
            currentInsurance: selectedInsured,
            birthDate: birthdate == "" ? new Date() : birthdate,
            callRep: callRep,
            currentInsuranceHowLong: selectedInsuredDuration,
            numberOfVehicle: vehicles,
            deductibles: deductibles,
            renewalDate: renewalDate,
            vehicleYear: selectedYear,
            vehicleMake: selectedMake,
            vehicleModel: selectedModel,
            additionalDrivers: additionalDrivers,
            additionalDriversName: additionalDriversName,
            additionalDriversBirthdate:  additionalDriversBirthdate == "" ? new Date() : additionalDriversBirthdate,
            replaceRoof: replaceRoof,
            priorInsuranceCompany: selectedInsuredBefore,
            homeowner: isHomeowner,
            incidents: incidents,
            notes: notes,
            propertyType: propertyType
            
        };
        try {
                const response = await fetch('https://api.leadmanagertraining.com/api/chat/PostLeadForm', { 
                    method: 'POST', 
                    body: JSON.stringify(request),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                const resp = await response.json();
                console.log(resp);
                if(resp.response != "Success")
                {
                    setIsSaving(false);
                    //alert("An error has occurred, please try again later.");
                }
                else {
                    setIsSaving(false);
                    setAddress("");
                    setCity("");
                    setState("");
                    setZip("");
                    setFirstName("");
                    setLastName("");
                    setPhone(""); 
                    setEmail("");
                    setSelectedInsured("");
                    setBirthdate("");
                    setCallRep("");
                    setSelectedInsuredDuration("");
                    setVehicles("");
                    setDeductibles("");
                    setRenewalDate("");
                    setSelectedYear("");
                    setSelectedMake("");
                    setSelectedModel("");
                    setAdditionalDrivers("");
                    setAdditionalDriversName("");
                    setAdditionalDriversBirthdate("");
                    setReplaceRoof("");
                    setSelectedInsuredBefore("");
                    setIsHomeowner("");
                    setNotes("");
                    setPropertyType("");
                    setShow(true);
                }
        }
        
        catch(e) {
            console.log('Submit Failed', e);
        }
        
    };

    const handleYearChange = async (e) => {
        setSelectedYear(e.target.value);
        InsertProgress("Vehicles [Select Make]");
        const response = await fetch("https://humble100.leadmanagertraining.com/api/autoquote/getMakes?year=" + e.target.value, { 
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        const jsonResponse = await response.json();
        setMakes(jsonResponse);
        
    };

    const handleMakeChange = async (e) => {
        setSelectedMake(e.target.value);
        InsertProgress("Vehicles [Select Model]");
        const response = await fetch("https://humble100.leadmanagertraining.com/api/autoquote/getModels?year=" + selectedYear + "&make=" + e.target.value, { 
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
        const jsonResponse = await response.json();
        setModels(jsonResponse);
    };

    const handleModelChange = async (e) => {
        setSelectedModel(e.target.value);
        
    };

    const handleInsuredChange = async (e) => {
        console.log(e.target.value);
        setSelectedInsured(e.target.value);
    };

    const handlePropertyTypeChange = async (e) => {
        console.log(e.target.value);
        setPropertyType(e.target.value);
    };

    const handleInsuredDurationChange = async (e) => {
        setSelectedInsuredDuration(e);
    };

    const handlePersonalContinue = async () => {
        var index = personalIndex;
        var requiredField = false;
        var emailInvalid = false;
        var message = "Field is required!"
        switch(index) {
            // case 1:
            //     InsertProgress("Personal [Birthdate]");
            //     requiredField = birthdate == "" && true;
            //     break;
            // case 2:
            //     InsertProgress("Personal [Gender]");
            //     requiredField = gender == "" && true;
            //     break;
            // case 3:
            //     InsertProgress("Personal [Married]");
            //     requiredField = isMarried == "" && true;
            //     break;
            // case 4:
            //     InsertProgress("Personal [Accidents]");
            //     requiredField = hasAccidents == "" && true;
            //     break;
            // case 5:
            //     InsertProgress("Personal [Dui]");
            //     requiredField = hasDui == "" && true;
            //     break;
            case 1:
                InsertProgress("Personal [Name]");
                requiredField = firstName == "" || lastName == "" && true;
                break;
            case 2:
                InsertProgress("Personal [Address]");
                if(address == "" || city == "" || state == "" || zip == ""){
                    requiredField = true;
                } else {
                    let zipCodeRegex = /(^\d{5}$)/;
                    if (!zipCodeRegex.test(zip)) {
                        requiredField = true;
                        message = "Invalid Zip"
                    }
                }
                break;
            case 3:
                InsertProgress("Personal [Email]");
                if(email == "")
                {
                    requiredField = true;
                } else {
                    let emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;
                    if (!emailRegex.test(email)) {
                        requiredField = true;
                        message = "Invalid email"
                    }
                }
                break;
            case 4:
                InsertProgress("Personal [Phone]");
                
                if(phone == "")
                    {
                        requiredField = true;
                    } else {
                        let phoneRegex = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
                        if (!phoneRegex.test(phone)) {
                            requiredField = true;
                            message = "Invalid phone"
                        }
                    }
                break;
            default:
              break;
        }
        setRequired(requiredField);
        setErrorMessage(message);
        console.log(required);
        if(requiredField == false){
            if(personalIndex < 4){
                index++;
            }
            setPersonalIndex(index);
            console.log(personalIndex);
            if(personalIndex >= 4){
                formWizardRef.current?.nextTab();
            }
        }
    };
    const handlePersonalBack = async () => {
        setRequired(false);
        var index = personalIndex;
        if(index > 1)
        {
            index--;
        }
        setPersonalIndex(index);
        console.log(personalIndex);
        
    };
    const handleAddAnotherVehicle = async (e) => {
        InsertProgress("Vehicles [Add Another Vehicle]");
        setSelectedMake("");
        setSelectedModel("");
        setSelectedYear("");
    };

    const tabChanged = ({prevIndex, nextIndex}) => {
        console.log("prevIndex", prevIndex);
        console.log("nextIndex", nextIndex);
        console.log(confirm);
        if(prevIndex != currentTab){
            if(prevIndex == 1){
                console.log(vehicles);
                InsertProgress("Insured");
            }
            if(prevIndex == 2 ){
                InsertProgress("Homeowner");
            }
            if(prevIndex == 3 ){
                console.log("Inside Tab Changed Personal");
                InsertProgress("Confirm");
            }
            if(prevIndex == 4 ){
                InsertProgress("Review");
            }
        }
        setCurrentTab(prevIndex);
    };
    const handleConfirmClick = () => {
        InsertProgress("Review [Clicked Confirm]");
        var valConfirm = confirm;
        setConfirm(!valConfirm);
        console.log(confirm);
    };
    let insCarriersList = insCarriers.map(a => a.name);// insCarriersList = require('../data/inscarriers.json');
    const stateList = require('../data/states.json');
    const days = [];
    for(let i=1; i <= 31; i++){
        days.push(i);
    }
    const dobYears = [];
    for(let i=2008; i >= 1940; i--){
        dobYears.push(i);
    }
    return (
        <div>
            <Row>
                <Col lg={{span: 6, offset: 3}}>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="Call Rep" style={{marginBottom: 10}} onChange={(e) => setCallRep(e.target.value)} value={callRep} name="callRep" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="First Name" style={{marginBottom: 10}} onChange={(e) => setFirstName(e.target.value)} value={firstName} autocomplete="given-name" />
                        <Form.Control type="text" placeholder="Last Name" onChange={(e) => setLastName(e.target.value)} value={lastName} autocomplete="family-name" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="Address" style={{marginBottom: 10}} onChange={(e) => setAddress(e.target.value)} value={address} autocomplete="street-address" />
                        <Row>
                            <Col xs={4}>
                                <Form.Control type="text" placeholder="City" onChange={(e) => setCity(e.target.value)} value={city} />
                            </Col>
                            <Col xs={4}>
                                <Form.Control as="select" onChange={(e) => setState(e.target.value)} value={state} className="form-select" placeholder="State">
                                <option key = 'blankChoice' hidden value>State</option>
                                    {stateList.sort().map(i => 
                                        <option key={i.abbreviation} value={i.abbreviation}>{i.name}</option>
                                    )}
                                </Form.Control>
                            </Col>
                            <Col xs={4}>
                                <Form.Control type="text" placeholder="Zip" onChange={(e) => setZip(e.target.value)} value={zip} autocomplete="postal-code" />
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <MaskedFormControl placeholder="Birthdate" type='text' mask='11/11/1111' onChange={(e) => setBirthdate(e.target.value)} value={birthdate} name="birthdate" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="email" placeholder="Email" style={{marginBottom: 10}} onChange={(e) => setEmail(e.target.value)} value={email} name="email" autocomplete="email" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <MaskedFormControl placeholder="Phone" type='text' mask='111-111-1111' onChange={(e) => setPhone(e.target.value)} value={phone} name="tel" autocomplete="tel" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={{span: 6, offset: 3}}>
                    <div>
                        <div style={{marginTop: 30}}>
                            <Form.Label style={{fontWeight: 'bold'}}>Current Insurance Company</Form.Label>
                            <Typeahead id="currentInsurance" as="select" onChange={(selected) => {setSelectedInsured(selected[0])}} value={selectedInsured} className="form-select" options={insCarriersList.sort()} labelKey="name">
                            </Typeahead>
                        </div> 
                        <div style={{marginTop: 30}}>
                            <div>
                                <Form.Label style={{fontWeight: 'bold'}}>How long have you had continuous coverage without gaps?</Form.Label>
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <Button style={{marginTop: 10, width: '75%'}} variant={selectedInsuredDuration == 'less than a year' ? "primary" : "light"} onClick={() => handleInsuredDurationChange('less than a year')}>less than a year</Button>
                                    <Button style={{marginTop: 10, width: '75%'}} variant={selectedInsuredDuration == '1-2 years' ? "primary" : "light"} onClick={() => handleInsuredDurationChange('1-2 years')}>1-2 years</Button>
                                    <Button style={{marginTop: 10, width: '75%'}} variant={selectedInsuredDuration == '2-3 years' ? "primary" : "light"} onClick={() => handleInsuredDurationChange('2-3 years')}>2-3 years</Button>
                                    <Button style={{marginTop: 10, width: '75%'}} variant={selectedInsuredDuration == '3-5 years' ? "primary" : "light"} onClick={() => handleInsuredDurationChange('3-5 years')}>3-5 years</Button>
                                    <Button style={{marginTop: 10, width: '75%'}} variant={selectedInsuredDuration == '5+ years' ? "primary" : "light"} onClick={() => handleInsuredDurationChange('5+ years')}>5+ years</Button>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop: 30, display: selectedInsuredDuration == 'less than a year' ? 'block' : 'none'}}>
                            <Form.Label style={{fontWeight: 'bold'}}>Insurance Company Before {selectedInsured}?</Form.Label>
                            <Typeahead id="priorInsurance" as="select" onChange={(selected) => {console.log(selected[0]); setSelectedInsuredBefore(selected[0]);}} value={selectedInsuredBefore} className="form-select" options={insCarriersList.sort()} labelKey="name">
                            </Typeahead>
                        </div> 
                        <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                            <Form.Control type="text" placeholder="Deductibles" style={{marginBottom: 10}} onChange={(e) => setDeductibles(e.target.value)} value={deductibles} name="deductibles" />
                        </Form.Group>
                        <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                            <MaskedFormControl placeholder="Renewal Date" type='text' mask='11/11/1111' onChange={(e) => setRenewalDate(e.target.value)} value={renewalDate} name="renewalDate" />
                        </Form.Group>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col lg={{span: 6, offset: 3}}>
                    <Form.Group style={{marginTop: 20}}>
                        <div>
                            <Form.Label style={{fontWeight: 'bold'}}>Homeowner?</Form.Label>
                        </div>
                        <div>
                            <Button size="lg" style={{marginRight: 20}} variant={isHomeowner ? "primary" : "light"} onClick={() => {setIsHomeowner(true)}}>Yes</Button>
                            <Button size="lg" variant={isHomeowner != "" && !isHomeowner ? "primary" : "light"} onClick={() => {setIsHomeowner(false)}}>No</Button>
                        </div>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control as="select" onChange={handlePropertyTypeChange} value={propertyType} className="form-select">
                            <option key = 'blankChoice' hidden value>Property Type</option>
                            <option key={1} value="Single Single Family">Single Single Family</option>
                            <option key={2} value="Condo">Condo</option>
                            <option key={3} value="Townhome">Townhome</option>
                            <option key={4} value="Apartment">Apartment</option>
                            <option key={5} value="Manufactured home">Manufactured home</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="Number of Vehicles" style={{marginBottom: 10}} onChange={(e) => setVehicles(e.target.value)} value={vehicles} name="vehicles" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control placeholder="Vehicle Year" as="select" onChange={handleYearChange} value={selectedYear} className="form-select">
                            <option key = 'blankChoice' hidden value>Vehicle Year</option>
                            {years.map(y => 
                                <option key={y} value={y}>{y}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control as="select" onChange={handleMakeChange} value={selectedMake} className="form-select">
                            <option key = 'blankChoice' hidden value>Vehicle Make</option>
                            {makes.map(make => 
                                <option key={make.id} value={make.name}>{make.name}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control as="select" onChange={handleModelChange} value={selectedModel} className="form-select">
                            <option key = 'blankChoice' hidden value>Vehicle Model</option>
                            {models.map(model => 
                                <option key={model.id} value={model.name}>{model.name}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group style={{marginTop: 20}}>
                        <div>
                            <Form.Label style={{fontWeight: 'bold'}}>Additional Drivers?</Form.Label>
                        </div>
                        <div>
                            <Button size="lg" style={{marginRight: 20}} variant={additionalDrivers ? "primary" : "light"} onClick={() => {setAdditionalDrivers(true)}}>Yes</Button>
                            <Button size="lg" variant={!additionalDrivers ? "primary" : "light"} onClick={() => {setAdditionalDrivers(false)}}>No</Button>
                        </div>
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20, display: additionalDrivers ? 'block' : 'none'}}>
                        <Form.Control type="text" placeholder="Additional Drivers Name" style={{marginBottom: 10}} onChange={(e) => setAdditionalDriversName(e.target.value)} value={additionalDriversName}  />
                        <MaskedFormControl placeholder="Additional Drivers Birthdate" type='text' mask='11/11/1111' onChange={(e) => setAdditionalDriversBirthdate(e.target.value)} value={additionalDriversBirthdate}  />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="How many incidents in the last 3 years?" style={{marginBottom: 10}} onChange={(e) => setIncidents(e.target.value)} value={incidents} name="incidents" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control type="text" placeholder="How old is the roof on your house?" style={{marginBottom: 10}} onChange={(e) => setReplaceRoof(e.target.value)} value={replaceRoof} name="replaceRoof" />
                    </Form.Group>
                    <Form.Group style={{textAlign: 'center', marginTop: 20}}>
                        <Form.Control as="textarea" rows={3} placeholder="Notes" style={{marginBottom: 10}} onChange={(e) => setNotes(e.target.value)} value={notes} name="notes" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col lg={{span: 6, offset: 3}}>
                    <Button type="submit" disabled={isSaving} size="lg" style={{marginRight: 20}} variant="primary" onClick={handleComplete} >
                        {isSaving ? "Saving..." : "Submit"}
                    </Button>
                    <Alert key="danger" variant="danger" style={{display: validated ? 'block' : 'none'}}>
                        Please fill out all required fields
                    </Alert>
                </Col>
            </Row>
            <Toast onClose={() => setShow(false)} show={show} delay={3000} autohide>
                <Toast.Header>
                    <strong className="me-auto">Lead Form</strong>
                </Toast.Header>
                <Toast.Body>Form Has Saved Successfully!</Toast.Body>
            </Toast>
        </div>
    )
};

export default LeadForm;